export const translation = {
    balanced: "balanceado",
    conservative: "conservador",
    sophisticated: "sofisticado"
}